module.exports = {
	message: {
		title: '中文'
	},
};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js